const inventoryPaymentSetupSectionStyles = {
    container: {
        backgroundColor: "#FFFFFF",
        px: { xs: "20px", sm: "40px", md: "40px", lg: "90px" },
    },
    image: {
        width: "100%",
        height: "100%",
        maxWidth: "597.47px",
        maxHeight: "619.15px",
    },
    headerContainer: {
        textAlign: "left",
        mt: { xs: "21.07px", sm: "25px", lg: "49.13px" },
    },
    headerText: {
        fontSize: { xs: "24px", sm: "32px", md: "40px" },
        fontWeight: "400",
        lineHeight: { xs: "24px", sm: "36px", md: "48px" },
        color: "#0F0F0F",
        fontFamily: "Belleza",
    },
    headerLine: {
        width: { xs: "67.18px" },
        height: { xs: "1px" },
        backgroundColor: "#0F0F0F",
        mt: { xs: "11.02px", sm: "25.03px" },
        mb: { xs: "15.76px", sm: "21.76px" },
    },
    headerDescription: {
        fontSize: { xs: "11px", sm: "15px", md: "16px" },
        fontWeight: "300",
        lineHeight: { xs: "14px", sm: "18px", md: "22px" },
        color: "#0F0F0F",
        fontFamily: "Lexend",
        mb: { xs: "15.21px", sm: "25px", md: "30px", lg: "46.1px" },
    },

    stepItem: {
    },
    stepNumber: {
        fontSize: { xs: "11.82px", sm: "16px" },
        fontWeight: { xs: "700", sm: "600"},
        color: { xs: "#808080", sm: "#0F0F0F"},
        fontFamily: "Lexend",
        minWidth: { xs: "60px", sm: "70px" },
        mb: { xs: "3.21px", sm: "9px" },
    },
    stepContent: {
        flex: 1,
    },
    stepTitle: {
        fontSize: { xs: "10.83px", sm: "18px" },
        fontWeight: { xs: "600", sm: "500"},
        color: "#0F0F0F",
        fontFamily: "Lexend",
        mb: { xs: "2.79px", sm: "5px" },
    },
    stepDescription: {
        fontSize: { xs: "11px", sm: "15px" },
        fontWeight: "300",
        lineHeight: { xs: "18px", sm: "20px" },
        color: "#666666",
        fontFamily: "Lexend",
    },
}

export default inventoryPaymentSetupSectionStyles;